const hotel = {
  availableMealPlans: "תכניות ארוחות זמינות", // translated
  availableRoomsTypes: "סוגי חדרים זמינים", // translated
  cancellationPolicy: "מדיניות ביטול", // translated
  cancellationRules: "כללי ביטול", // translated
  freeCancellationAvailable: "ביטול חינם זמין", // translated
  nonRefundable: "לא ניתן להחזיר", // translated
  priceFor: "מחיר בשביל", // translated
  nights: "לילות", // translated
  totalPrice: "מחיר סופי", // translated
  seeAvailability: "ראה זמינות", // translated
  myProfile: "הפרופיל שלי", // translated
  travelTrust: "אמון נסיעות", // translated
  signIn: "להתחבר", // translated
  searchNow: "חפש כעת", // translated
  policy: "מְדִינִיוּת", // translated
  cxlRules: "כללי CXL", // translated
  room: "חֶדֶר", // translated
  cxlPolicy: "מדיניות CXL", // translated
  beddingType: "סוג מצעים", // translated
  hotelName: "שם המלון", // translated
  reservationDate: "תאריך הזמנה", // translated
  maxPax: "מקס פאקס", // translated
};

export default hotel;
